import React, { useState, useEffect, useRef } from 'react';
import { getSelectedDaysCount } from '../cellcomAbroadUtilities';
import lodash from 'lodash';
import { useInView } from 'react-intersection-observer';
import { lobbyTabsEnum } from '../cellcomAbroadVariables';
import { connect } from 'react-redux';
import { isMobileOnly as isMobile, isTablet } from 'react-device-detect';
import { Container, Col, Row, Collapse, Button } from 'reactstrap';
import SubMainHeadlineComponent from '../SubMainHeadLineComponent';
import AbroadPackageClient from '../Shared/Components/AbroadPackage';
import StickySearchParametersHolderComponent from './StickySearchParametersHolderComponent';
import ShowMorePackagesButton from './ShowMorePackagesButton';
import ShowMoreNotExactPackagesButton from './ShowMoreNotExactPackagesButton';
import StickyOrderPackageButton from './StickyOrderPackageButton';
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent, gtag4 } from '../../../../utilities/analytics/tracking';
import { PackageOrigin } from '../Shared/Models/AbroadPackageModels';
import { Fragment } from 'react';
import {
  gaSearchPackagesResult,
  gaOrderingButtonClick,
  gaSearchPackagesPartanyResult,
  gaToggleValidyButNotExactbutton,
} from './../gaReports';

const CellcomAbroadPackagesHolderComponent = (props) => {
  const [shownPackagesCount, setShownPackagesCount] = useState(props.data.epiStyleInitializationData.numberOfPackagesToShow);
  const [validyButNotExactOpen, setValidyButNotExactOpen] = useState(false);
  const [businessOrgMatchPackagesOpen, setBusinessOrgMatchPackagesOpen] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  const packagesWrapperRef = useRef(null);

  useEffect(() => {
    if (inView) gaReportNotMatchInView();
  }, [inView]);

  const toggle = () => {
    gaToggleValidyButNotExactbutton(
      props.data.activeLobbyTab,
      props.data.otpData.validatedCostumerData?.isSeparatedSale,
      props.businessIndividual
    );

    setValidyButNotExactOpen(!validyButNotExactOpen);
  };

  const toggleBusiness = () => {
    setBusinessOrgMatchPackagesOpen(!businessOrgMatchPackagesOpen);
  };

  useEffect(() => {
    if (props.data.abroadPackagesList) {
      let count =
        parseInt(props.data.abroadPackagesList.matchExact.length) + parseInt(props.data.abroadPackagesList.validyButNotExact.length);

      if (props.businessIndividual) {
        if (props.data.businessIndividualData.viewWithoutPurchaseStatus) {
          if (props.data.selectedCountries?.length > 0) {
            gaSearchPackagesPartanyResult(true);
          } else {
            gaSearchPackagesPartanyResult(false);
          }
        } else {
          gaSearchPackagesResult(props.data.activeLobbyTab, count, false, true);
        }
      } else {
        gaSearchPackagesResult(props.data.activeLobbyTab, count, props.data.otpData.validatedCostumerData?.isSeparatedSale, false);
      }
      focusOnSearchResults()
    }
  }, [props.data.abroadPackagesList]);

  useEffect(() => {
    if (props.data.searchIsLoading) {
      setShownPackagesCount(props.data.epiStyleInitializationData.numberOfPackagesToShow);
    }
  }, [props.data.searchIsLoading]);

  function focusOnSearchResults() {
    if (isMobile || isTablet) {
      if (packagesWrapperRef.current) {
        const topOffset = packagesWrapperRef.current.getBoundingClientRect().top + window.scrollY - 110 - parseInt(props.data.epiStyleInitializationData.spacingBetweenSearchAndResultDataMobile);
        window.scrollTo({ top: topOffset, behavior: 'smooth' });
      }
    }
  }

  const gaAndShowMore = () => {
    switch (props.data.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gtag4({
          event: 'CellcomAbroad_Step3_ShowMorePackages',
          button: 'המשך',
          step: '3',
          action: 'ShowMorePackages',
          process_type: 'private',
          funnel_name: '2 - SearchArea',
        });
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_SHOWMORE_CLICK.category,
            gaParams.SEPARATED_SHOWMORE_CLICK.eventType,
            gaParams.SEPARATED_SHOWMORE_CLICK.eventParams
          );
        } else {
          gtag4({
            event: 'CellcomAbroad_Step4_MorePackagesButton',
            button: 'תראו לי עוד חבילות חו"ל',
            step: '4',
            action: 'MorePackagesButton',
            process_type: 'business',
            funnel_name: '2 - SearchArea - Business',
          });
        }
        break;
      default:
        break;
    }
    setShownPackagesCount(shownPackagesCount + parseInt(props.data.epiStyleInitializationData.numberOfPackagesToShow));
  };

  const gaAndOrder = (selectedPackage) => {
    gaOrderingButtonClick(selectedPackage, props.data.activeLobbyTab, props.data.otpData.validatedCostumerData?.isSeparatedSale, props.businessIndividual);
    props.orderEvent(selectedPackage);
  };

  function gaReportNotMatchInView() {
    const codePackages = lodash.map(props.data.abroadPackagesList.validyButNotExact, 'socCode');

    switch (props.data.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        if (!props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_LOBBY_NOT_EXACT_PACKAGES_ARE_SHOWN_PRIVATE.category,
            gaParams.ABROAD_LOBBY_NOT_EXACT_PACKAGES_ARE_SHOWN_PRIVATE.eventType,
            codePackages
          );
        }
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (!props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_LOBBY_NOT_EXACT_PACKAGES_ARE_SHOWN_BUSINESS.category,
            gaParams.ABROAD_LOBBY_NOT_EXACT_PACKAGES_ARE_SHOWN_BUSINESS.eventType,
            codePackages
          );
        }

        break;
      default:
        break;
    }
  }

  const ifVisible = (index) => {
    if (props.businessIndividual) return true;
    return index + 1 <= shownPackagesCount;
  };

  const getSearchBlockTitle = () => {
    let title = `מצאנו חבילות שמתאימות לך במיוחד`;
    if (props.businessIndividual) {
      let companyName;
      if (props.data.epiStyleInitializationData.businessIndividualLobby) {
        companyName = props.portalsBlock.privateCompanyList.find((org) => org.idNumber == props.portalsBlock.selectedHetPay).orgName;
      } else {
        companyName = props.data.otpData?.validatedCostumerData?.orgName || '';
      }

      title = `<div>כל החבילות של <span class="black">${companyName}</span></div>`;
    }
    return title;
  };

  return (
    <Container className='packages-wrapper'>
      <div ref={packagesWrapperRef}>
        <SubMainHeadlineComponent
          title={getSearchBlockTitle()}
          subTitle={props.businessIndividual ? `<div>שמתאימות לחיפוש שלך</div>` : ''}
          isSmallResolution={props.data.isSmallResolution}
          isPortrait={props.data.isPortrait}
        />
        {props.data.selectedCountriesUsedInSearch.length > 0 &&
          props.data.dates.datePickerStartJSFormat &&
          props.data.dates.datePickerEndJSFormat && (
            <StickySearchParametersHolderComponent
              selectedCountries={props.data.selectedCountriesUsedInSearch}
              selectedDaysCount={getSelectedDaysCount(props.data.dates.datePickerStartJSFormat, props.data.dates.datePickerEndJSFormat)}
            />
          )}

        {props.data.abroadPackagesList.matchExact?.length > 0 ? (
          <div className='packages-holder'>
            <Row className='justify-content-center'>
              {props.data.abroadPackagesList.matchExact.map((abroadPackage, index) => {
                if (ifVisible(index)) {
                  return (
                    <Fragment key={index}>
                      <Col
                        className={` ${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-4'
                          }`}>
                        <AbroadPackageClient
                          packageData={abroadPackage}
                          key={index}
                          orderEvent={(selectedPackage) => gaAndOrder(selectedPackage)}
                          supportedApps={props.data.getEpiGeneralData.supportedApps}
                          context={props.context}
                          isSearchOrPopular={PackageOrigin.SEARCH}
                          isPrivateOrBusiness={props.data.activeLobbyTab}
                          isSeparatedSale={props.data.otpData.validatedCostumerData?.isSeparatedSale}
                          viewWithoutPurchaseStatus={props.data.businessIndividualData.viewWithoutPurchaseStatus ? true : false}
                          selectedCountriesCount={props.data.selectedCountriesUsedInSearch?.length}
                        />
                      </Col>

                      {!props.businessIndividual &&
                        index + 1 == shownPackagesCount &&
                        props.data.abroadPackagesList.matchExact.length == shownPackagesCount + 1 && (
                          <Col
                            className={` ${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-4'
                              }`}>
                            <AbroadPackageClient
                              packageData={props.data.abroadPackagesList.matchExact[index + 1]}
                              key={index + 1}
                              orderEvent={(selectedPackage) => gaAndOrder(selectedPackage)}
                              supportedApps={props.data.getEpiGeneralData.supportedApps}
                              context={props.context}
                              isSearchOrPopular={PackageOrigin.SEARCH}
                              isPrivateOrBusiness={props.data.activeLobbyTab}
                              isSeparatedSale={props.data.otpData.validatedCostumerData?.isSeparatedSale}
                              viewWithoutPurchaseStatus={props.data.businessIndividualData.viewWithoutPurchaseStatus ? true : false}
                              selectedCountriesCount={props.data.selectedCountriesUsedInSearch?.length}
                            />
                          </Col>
                        )}
                    </Fragment>
                  );
                }
              })}
            </Row>

            {!props.businessIndividual && shownPackagesCount + 1 < props.data.abroadPackagesList.matchExact.length && (
              <Row>
                <Col
                  className={`show-more-holder text-center ${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'margin-bottom-140' : ''
                    }`}>
                  <ShowMorePackagesButton onClick={() => gaAndShowMore()} title={'תראו לי עוד חבילות חו"ל'} />
                </Col>
              </Row>
            )}
          </div>
        ) : (
          <Container>
            <Row>
              <Col className='text-center'>לא מצאנו חבילות שמתאימות לחיפוש שלך.</Col>
            </Row>
          </Container>
        )}

        {props.data.abroadPackagesList.validyButNotExact?.length > 0 &&
          (props.businessIndividual ||
            !props.data.abroadPackagesList.matchExact ||
            (props.data.abroadPackagesList.matchExact && shownPackagesCount + 1 >= props.data.abroadPackagesList.matchExact.length)) && (
            <div className='packages-holder'>
              <Row
                className={`justify-content-center ${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'margin-bottom-55' : ''
                  }`}>
                <Col className='text-center'>
                  <ShowMoreNotExactPackagesButton
                    onClick={toggle}
                    isOpen={validyButNotExactOpen}
                    mainText={` תרצו לראות עוד חבילות?`}
                    subText={`${!props.businessIndividual && !props.data.abroadPackagesList.businessIndividual
                      ? 'הן עונות על חלק מההגדרות ויכולות להתאים למה שאתם מחפשים'
                      : ''
                      }  `}
                  />
                </Col>
              </Row>
              <Collapse isOpen={validyButNotExactOpen} className='not-exact-packages-wrapper'>
                <Row className='justify-content-center'>
                  {props.data.abroadPackagesList.validyButNotExact.map((abroadPackage, index) => {
                    return (
                      <Fragment key={index}>
                        <div
                          className={`${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-4'
                            }`}
                          ref={
                            index == Math.round(props.data.abroadPackagesList.validyButNotExact.length / 2) ||
                              props.data.abroadPackagesList.validyButNotExact.length == 1
                              ? ref
                              : null
                          }>
                          <AbroadPackageClient
                            packageData={abroadPackage}
                            key={index}
                            orderEvent={(selectedPackage) => gaAndOrder(selectedPackage)}
                            supportedApps={props.data.getEpiGeneralData.supportedApps}
                            context={props.context}
                            isSearchOrPopular={PackageOrigin.SEARCH}
                            isPrivateOrBusiness={props.data.activeLobbyTab}
                            selectedCountriesCount={props.data.selectedCountriesUsedInSearch?.length}
                          />
                        </div>
                      </Fragment>
                    );
                  })}
                </Row>
              </Collapse>
            </div>
          )}
        {props.data.abroadPackagesList.businessOrgMatchPackages?.length > 0 &&
          (props.businessIndividual ||
            !props.data.abroadPackagesList.matchExact ||
            (props.data.abroadPackagesList.matchExact && shownPackagesCount + 1 >= props.data.abroadPackagesList.matchExact.length)) && (
            <div className='packages-holder'>
              <Row
                className={`justify-content-center ${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'margin-bottom-55' : ''
                  }`}>
                <Col className='text-center'>
                  <ShowMoreNotExactPackagesButton
                    onClick={toggleBusiness}
                    isOpen={businessOrgMatchPackagesOpen}
                    mainText={`תרצו לראות חבילות ?פרטניות לחברה שלכם`}
                    subText={`חבילות אלה ניתנות לרכישה רק דרך איש הקשר`}
                  />
                </Col>
              </Row>

              <Collapse isOpen={businessOrgMatchPackagesOpen} className='not-exact-packages-wrapper'>
                <Row className='justify-content-center'>
                  {props.data.abroadPackagesList.businessOrgMatchPackages.map((abroadPackage, index) => {
                    return (
                      <Fragment key={index}>
                        <div
                          className={`${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-4'
                            }`}
                          ref={
                            index == Math.round(props.data.abroadPackagesList.businessOrgMatchPackages.length / 2) ||
                              props.data.abroadPackagesList.businessOrgMatchPackages.length == 1
                              ? ref
                              : null
                          }>
                          <AbroadPackageClient
                            packageData={abroadPackage}
                            key={index}
                            orderEvent={(selectedPackage) => gaAndOrder(selectedPackage)}
                            supportedApps={props.data.getEpiGeneralData.supportedApps}
                            context={props.context}
                            isSearchOrPopular={PackageOrigin.SEARCH}
                            isPrivateOrBusiness={props.data.activeLobbyTab}
                            viewWithoutPurchaseStatus={true}
                            selectedCountriesCount={props.data.selectedCountriesUsedInSearch?.length}
                          />
                        </div>
                      </Fragment>
                    );
                  })}
                </Row>
              </Collapse>
            </div>
          )}

        {/* View org packages for business customers  */}
        {props.data.businessIndividualData.viewWithoutPurchaseStatus && (
          <StickyOrderPackageButton changeAccountBusinessIndividual={props.changeAccountBusinessIndividual} />
        )}
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    portalsBlock: state.portalsBlock,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CellcomAbroadPackagesHolderComponent);
